<template>
  <div>
    <form @submit.prevent="onSubmit">
      <div class="field">
        <label class="label">Title</label>
        <div class="control has-icons-right mt-2">
          <input
            type="text"
            class="input"
            v-model="localPage.attributes.title"
            name="title"
            required
          />
        </div>
      </div>
      <div class="field is-grouped mt2 has-text-right">
        <div class="control">
          <button :class="['button', 'is-primary', { 'is-loading': loading }]">
            Update
          </button>
          <button
            type="button"
            class="button is-link"
            @click="$emit('hidePage')"
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import _ from "lodash";
import InterviewsService from "@/services/InterviewsService";

export default {
  name: "page-edit",

  props: ["page", "interviewId"],

  data() {
    return {
      loading: false,
      localPage: _.cloneDeep(this.page)
    };
  },

  methods: {
    onSubmit() {
      this.loading = true;
      const interviewId = this.$route.params.id;
      InterviewsService.updatePage(
        this.interviewId,
        this.localPage,
        interviewId
      ).then(() => {
        this.loading = false;
        this.$emit("hidePage");
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
